<template>
  <RygenChip
    class="dock-appointment-status-chip"
    :label="
      dockAppointment.data?.status
        ? translateEnum(dockAppointment.data.status, 'DockAppointmentStatus')
        : ''
    "
    :severity="dockAppointmentStatusSeverity"
  />
</template>

<script lang="ts" setup>
import { computed, PropType, toRefs } from 'vue';

import { translateEnum } from '@rygen/rygen-ui/i18n';
import { Loadable, Severity } from '@rygen/rygen-ui/model';

import {
  DANGER_STATUSES,
  DockAppointment,
  SUCCESS_STATUSES,
  WARNING_STATUSES,
} from '@/model';

import RygenChip from '@rygen/rygen-ui/components/ui/RygenChip.vue';

const props = defineProps({
  dockAppointment: {
    type: Object as PropType<Loadable<DockAppointment>>,
    required: true,
  },
});
const { dockAppointment } = toRefs(props);

const dockAppointmentStatusSeverity = computed(() => {
  if (!dockAppointment.value.data?.status) {
    return Severity.INFO;
  } else if (SUCCESS_STATUSES.includes(dockAppointment.value.data.status)) {
    return Severity.SUCCESS;
  } else if (WARNING_STATUSES.includes(dockAppointment.value.data.status)) {
    return Severity.WARNING;
  } else if (DANGER_STATUSES.includes(dockAppointment.value.data.status)) {
    return Severity.DANGER;
  } else {
    return Severity.INFO;
  }
});
</script>
